import { render, staticRenderFns } from "./orderStatusDialogs.vue?vue&type=template&id=bcf757a8&scoped=true&"
import script from "./orderStatusDialogs.vue?vue&type=script&lang=js&"
export * from "./orderStatusDialogs.vue?vue&type=script&lang=js&"
import style0 from "./orderStatusDialogs.vue?vue&type=style&index=0&id=bcf757a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf757a8",
  null
  
)

export default component.exports